const CatalogDepartments = () =>
  import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/Catalogs/Department/Departments.vue');

const CatalogTerritories = () =>
  import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/Catalogs/Territory/Territories.vue');

const CatalogCountries = () =>
  import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/Catalogs/Country/List.vue');

export default [
  {
    path: 'departments',
    name: 'catalog-departments',
    component: CatalogDepartments,
  },
  {
    path: 'territories',
    name: 'catalog-territories',
    component: CatalogTerritories,
  },
  {
    path: 'countries',
    name: 'catalog-countries',
    component: CatalogCountries,
  },
];
